import { computed, makeAutoObservable } from "mobx";

import { KnowledgeBaseReadChatbot, SupportedAiModelResponse } from "../../@api";

import { translationKeys } from "../models/app-translation-keys";

const LOCAL_STORAGE_KEY_SELECTED_KNOWLEDGEBASE = "selectedKnowledgeBase";

const DEFAULT_KNOWLEDGE_BASE: ICustomKnowledgeBaseReadChatbot = {
  name: translationKeys.feature.chatbot.knowledgebases.defaultTitle,
  isSpoKnowledgeBase: false,
  isDefault: true,
  id: "",
};

export interface ICustomKnowledgeBaseReadChatbot extends KnowledgeBaseReadChatbot {
  isDefault?: boolean;
  siteId?: string;
}

export class ChatStore {
  private _knowledgeBases: ICustomKnowledgeBaseReadChatbot[] = [];
  private _selectedKnowledgeBase: ICustomKnowledgeBaseReadChatbot = DEFAULT_KNOWLEDGE_BASE;
  private _isKnowledgeBaseSelectionLoading = false;

  private _chatAiModelOptions: SupportedAiModelResponse[] = [];
  private _isChatAiModelOptionsLoading = false;

  constructor() {
    makeAutoObservable(this, { defaultKnowledgeBase: computed }, { autoBind: true });

    const saved = localStorage.getItem(LOCAL_STORAGE_KEY_SELECTED_KNOWLEDGEBASE);
    if (saved) {
      try {
        this._selectedKnowledgeBase = JSON.parse(saved);
      } catch {
        this._selectedKnowledgeBase = DEFAULT_KNOWLEDGE_BASE;
      }
    }
  }

  public get selectedKnowledgeBase(): ICustomKnowledgeBaseReadChatbot {
    return this._selectedKnowledgeBase;
  }

  public set selectedKnowledgeBase(knowledgeBase: ICustomKnowledgeBaseReadChatbot) {
    this._selectedKnowledgeBase = knowledgeBase;
    localStorage.setItem(LOCAL_STORAGE_KEY_SELECTED_KNOWLEDGEBASE, JSON.stringify(knowledgeBase));
  }

  public get defaultKnowledgeBase(): ICustomKnowledgeBaseReadChatbot {
    return DEFAULT_KNOWLEDGE_BASE;
  }

  public set isKnowledgeBaseSelectionLoading(isLoading: boolean) {
    this._isKnowledgeBaseSelectionLoading = isLoading;
  }

  public get isKnowledgeBaseSelectionLoading(): boolean {
    return this._isKnowledgeBaseSelectionLoading;
  }

  public set knowledgeBases(knowledgeBases: ICustomKnowledgeBaseReadChatbot[]) {
    this._knowledgeBases = knowledgeBases;
  }

  public get knowledgeBases(): ICustomKnowledgeBaseReadChatbot[] {
    return this._knowledgeBases;
  }

  public set chatAiModelOptions(chatAiModelOptions: SupportedAiModelResponse[]) {
    this._chatAiModelOptions = chatAiModelOptions;
  }

  public get chatAiModelOptions(): SupportedAiModelResponse[] {
    return this._chatAiModelOptions;
  }

  public set isChatAiModelOptionsLoading(isLoading: boolean) {
    this._isChatAiModelOptionsLoading = isLoading;
  }

  public get isChatAiModelOptionsLoading(): boolean {
    return this._isChatAiModelOptionsLoading;
  }
}
